import { avatarClasses } from "@mui/material/Avatar";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCardHeader = {
	defaultProps: {
		// `slotProps`, not the older `titleTypographyProps`: MUI v7 types the
		// deprecated prop as `TypographyProps<"span", { component?: "span" }>`, so
		// `component` cannot be widened through it at all.
		//
		// `component: "h6"` is not decoration — MUI bakes `component: "span"` into
		// the title slot, so without this a card title only looks like a heading and
		// is invisible to `getByRole("heading")` and to screen-reader heading
		// navigation. `h6` matches the shared `@/components/headers/card-header`,
		// which renders `Typography variant="h6"`, so both card headers land on one
		// heading level. Pinned by card-header.test.tsx.
		//
		// A title that is an element rather than a string gets wrapped too, so
		// loading skeletons must pass `disableTypography` to avoid an unnamed
		// heading.
		slotProps: {
			title: { variant: "h6", component: "h6" },
			subheader: { variant: "body2" },
		},
	},
	styleOverrides: {
		root: ({ theme }) => ({
			padding: theme.spacing(2, 2, 1),
			[theme.breakpoints.up("sm")]: {
				padding: theme.spacing(3, 3, 1.5),
			},
		}),
		avatar: {
			[`& .${avatarClasses.root}`]: {
				"--Icon-fontSize": "var(--icon-fontSize-lg)",
				backgroundColor: "var(--mui-palette-background-paper)",
				boxShadow: "var(--mui-shadows-8)",
				color: "var(--mui-palette-text-primary)",
			},
		},
	},
} satisfies Components<Theme>["MuiCardHeader"];
